// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3tMNA","sendOtp":"AuthorizeToLogin_sendOtp__3q5Jw"};